export const getDocsUrl = (ruleName: string): string =>
  `https://tanstack.com/query/latest/docs/eslint/${ruleName}`
